module.exports = "/packs/images/sprites/news~9e6151d142fb849d70ca50b426b2523f.png";